import { Routes, Route, Link } from "react-router-dom";
import Library from "./Pages/Library.jsx";
import AddBook from "./Pages/AddBook.jsx";
import BookDetail from "./Pages/BookDetail.jsx";
import Fun from "./Pages/Fun.jsx";

export default function App() {
return (
  <div style={{ maxWidth: 1100, margin: "24px auto", padding: "0 16px", fontFamily: "system-ui,sans-serif" }}>
    <nav
      style={{
        display: "flex",
        gap: 12,
        marginBottom: 16,
        fontSize: 14,
        flexWrap: "wrap",
      }}
    >
      <Link to="/" style={linkStyle}>Library</Link>
      <Link to="/add" style={linkStyle}>Add Book</Link>
      <Link to="/fun" style={linkStyle}>Fun</Link>
    </nav>

    <Routes>
      <Route path="/" element={<Library />} />
      <Route path="/add" element={<AddBook />} />
      <Route path="/book/:id" element={<BookDetail />} />
      <Route path="/fun" element={<Fun />} />
      <Route path="*" element={<div>Not Found</div>} />
    </Routes>
    
  </div>
)
}

const linkStyle = {
  textDecoration: "none",
  color: "#0ea5e9",
  fontWeight: 500,
};
